module.exports = __webpack_public_path__ + "static/scale-model-of-negro-leagues-baseball-museum-in-kansas-city-missouri-951acea2ca6005e2d2a50bd30d2b925f.png";